import {ObjectList} from './object-list.model.interface';
import {ISimpleSelectableData} from './simple-selectable-data.model.interface';

export interface IParcelType {
  id: number;
  label: string;
}

export class IParcelTypeList extends ObjectList<IParcelType, IParcelType> {
  protected mapToListElement(instance: IParcelType): IParcelType {
    return instance;
  }

  protected mapToSelectableItem(instance: IParcelType): ISimpleSelectableData {
    return {
      value: instance.id,
      label: instance.label
    };
  }
}
